<script setup lang="ts">
import { apps, log } from "@hantera/portal-app";
import AppSlotContext from "./AppSlotContext.vue";
import useApps from "./composition/use-apps";
import { computed, provide, reactive, readonly, watch } from "vue";


const props = defineProps<{
  slot: apps.AppSlot<unknown>,
  context?: Record<string, any>,
  appId?: string
}>();


const appsContext = useApps();

const context = reactive<Record<string, any>>({})

watch(() => props.context, () => {

  if (!props.context) {
    for (const key of Object.keys(context)) {
      delete context[key];
    }
    return;
  }

  const existingKeys = Object.keys(context);
  for (const [key, value] of Object.entries(props.context)) {
    context[key] = value;
    existingKeys.splice(existingKeys.indexOf(key), 1);
  }
  for (const key of existingKeys) {
    delete context[key];
  }

}, {
  deep: true,
  immediate: true,
})

provide('$portal_appComponentContext', (slot: apps.AppSlot<unknown>) => {

  if (slot.key !== props.slot.key) {
    const error = `Expected component context for '${slot.key}' but got '${props.slot.key}', make sure this component is registered in the correct slot`;
    log.err(error);
    throw new Error(error);
  }

  return {
    slot: props.slot.key,
    context: readonly(context)
  }
});

const components = computed(() => appsContext.getComponentsFor(props.slot, props.appId));
</script>

<template>
  <AppSlotContext
    v-for="c in components"

    :key="c.key"
    :app-component="c"
  />
</template>